import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Loader2 } from 'lucide-react';
import { TENANT_STATUS_LABELS_FR } from '@ci-ville/shared';
import { Badge } from '@ci-ville/ui';
import { parseDay } from '@/lib/dates';
/** Droits de l'équipe GEOSIRA dans la console (miroir de apps/api/src/auth/platform.ts). */
export function platformRights(user) {
    const superAdmin = !!user?.isSuperAdmin;
    return {
        superAdmin,
        support: superAdmin || user?.platformRole === 'SUPPORT',
        billing: superAdmin || user?.platformRole === 'BILLING',
        staff: superAdmin || !!user?.platformRole,
    };
}
export const fmtDate = (v, pattern = 'd MMM yyyy', empty = '') => v ? format(parseDay(v), pattern, { locale: fr }) : empty;
export function Kpi({ label, value, hint, tone }) {
    // Carte neutre : la tonalité ne colore que la valeur (voir .claude/skills/interface-sobre)
    const valueTone = tone === 'ok' ? 'text-success' : tone === 'warn' ? 'text-warning' : tone === 'bad' ? 'text-destructive' : '';
    return (_jsxs("div", { className: "rounded-lg border border-border bg-card p-3", children: [_jsx("p", { className: "text-xs font-medium text-muted-foreground", children: label }), _jsx("p", { className: `mt-1 text-2xl font-semibold tabular-nums ${valueTone}`, children: value }), hint && _jsx("p", { className: "text-[11px] text-muted-foreground", children: hint })] }));
}
const STATUS_TONE = {
    ACTIVE: 'success',
    TRIAL: 'brand',
    PAST_DUE: 'warning',
    SUSPENDED: 'danger',
    ARCHIVED: 'neutral',
};
export function TenantStatusPill({ status }) {
    return _jsx(Badge, { tone: STATUS_TONE[status] ?? 'neutral', children: TENANT_STATUS_LABELS_FR[status] ?? status });
}
export function Spinner() {
    return _jsx("div", { className: "flex h-40 items-center justify-center", children: _jsx(Loader2, { className: "size-6 animate-spin text-brand" }) });
}
export function Section({ title, actions, children }) {
    return (_jsxs("section", { className: "rounded-lg border border-border bg-card", children: [_jsxs("div", { className: "flex flex-wrap items-center justify-between gap-2 border-b border-border px-4 py-3", children: [_jsx("h2", { className: "text-sm font-semibold", children: title }), actions] }), children] }));
}
export function formatBytes(bytes) {
    if (bytes < 1024)
        return `${bytes} o`;
    if (bytes < 1024 ** 2)
        return `${(bytes / 1024).toFixed(0)} Ko`;
    if (bytes < 1024 ** 3)
        return `${(bytes / 1024 ** 2).toFixed(1)} Mo`;
    return `${(bytes / 1024 ** 3).toFixed(2)} Go`;
}
//# sourceMappingURL=console-ui.js.map